interface Tab {
  key: string;
  label: string;
  icon: string;
  count?: number;
}

interface ResponsiveCustomerTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

export default function ResponsiveCustomerTabs({ tabs, activeTab, onTabChange }: ResponsiveCustomerTabsProps) {
  return (
    <div className="bg-background-100 rounded-xl p-1 overflow-x-auto scrollbar-none">
      <div className="flex items-center gap-1 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-all whitespace-nowrap cursor-pointer active:scale-95 ${
              activeTab === tab.key
                ? 'bg-background-50 text-foreground-900 shadow-sm'
                : 'text-foreground-400 hover:text-foreground-600'
            }`}
            style={{ minHeight: 36 }}
          >
            <i className={`${tab.icon} ${activeTab === tab.key ? 'text-primary-500' : ''}`}></i>
            <span>{tab.label}</span>
            {tab.count !== undefined && (
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                  activeTab === tab.key
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-background-200 text-foreground-400'
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}